export default __webpack_public_path__ + "static/media/mg-dropdown.b4890c84.webp";